import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=0c935e02&scoped=true&"
import script from "./Funds.js?vue&type=script&lang=js&"
export * from "./Funds.js?vue&type=script&lang=js&"
import style0 from "./Funds.css?vue&type=style&index=0&id=0c935e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c935e02",
  null
  
)

export default component.exports